/**
 * Sätze der Vorgänge („Was passiert gerade“, Start → Fortschritt → Ende → Fehler). Klartext ohne Fachwörter; jeder
 * Fehler sagt, was zu tun ist (oder dass es von selbst weitergeht).
 */
export const VORGANG_TEXTE = {
  streifen: {
    region: 'Was gerade passiert',
    mehr: 'Alles anzeigen ({anzahl})',
    weniger: 'Weniger anzeigen',
    laeuft: 'Läuft gerade',
    hinweis: 'Hinweis',
    fertig: 'Fertig',
    braucht: 'Braucht deinen Betreuer',
    pausiert: 'Pausiert',
  },
  problem: {
    judgment_not_configured:
      'Die automatische Einordnung ist nicht eingerichtet. Bitte deinen Betreuer, sie einzurichten.',
    judgment_not_released:
      'Die automatische Einordnung ist eingerichtet, aber noch nicht freigeschaltet. Bitte deinen Betreuer, sie freizuschalten.',
    ai_not_configured:
      'Die Websuche und die Textvorschläge sind nicht eingerichtet. Bitte deinen Betreuer, sie einzurichten.',
    maps_not_configured:
      'Firmen werden nicht bei Google nachgeschlagen, weil das nicht eingerichtet ist. Unklare Kontakte landen deshalb öfter bei „bitte prüfen“. Dein Betreuer kann es einrichten.',
    audience_paused:
      'Die Einordnung pausiert bis {wann}, weil heute schon sehr viele Kontakte bewertet wurden. Danach geht es von selbst weiter.',
    audience_pausedAnzahl:
      'Die Einordnung pausiert bis {wann}, weil heute schon sehr viele Kontakte bewertet wurden. {anzahl} Kontakte sind dann als Nächstes dran, es geht von selbst weiter.',
    checks_paused:
      'Einige automatische Prüfungen pausieren bis {wann}, weil heute schon sehr viele gemacht wurden. Danach geht es von selbst weiter.',
    budget_exhausted:
      'Das Monatsguthaben für die automatische Hilfe ist aufgebraucht. Bis zum nächsten Monat bleibt sie aus. Bitte deinen Betreuer, das Guthaben zu erhöhen.',
    service_login_failed:
      'Die Anmeldung bei einem Hilfsdienst ist in den letzten 24 Stunden {anzahl}-mal gescheitert. Bitte deinen Betreuer, den Zugang zu prüfen.',
    service_unreachable:
      'Ein Hilfsdienst war in den letzten 24 Stunden {anzahl}-mal nicht erreichbar. Socialfy versucht es von selbst noch einmal.',
    judgments_failed:
      '{anzahl} automatische Bewertungen sind in den letzten 24 Stunden gescheitert. Betroffene Kontakte werden später noch einmal bewertet.',
    judgments_failedEins:
      'Eine automatische Bewertung ist in den letzten 24 Stunden gescheitert. Der betroffene Kontakt wird später noch einmal bewertet.',
    wann: '{tag} um {uhrzeit} Uhr',
    heute: 'heute',
    morgen: 'morgen',
  },
  lauf: {
    zielgruppe: 'Die Zielgruppe „{name}“ wird eingeordnet.',
    zielgruppeStand: 'Die Zielgruppe „{name}“ wird eingeordnet: {fertig} von {alle} Kontakten.',
    web: {
      queued: 'Die Websuche startet gleich.',
      searching: 'Die Websuche sucht Webseiten von Praxen und Kliniken.',
      structuring: 'Die Websuche liest die gefundenen Webseiten und prüft, wer die Praxis führt.',
    },
    einfuegen: 'Die eingefügten Treffer werden bewertet.',
    aufbereitung: 'Deine Daten werden aufbereitet.',
    aufbereitungStand: 'Deine Daten werden aufbereitet: {fertig} von {alle} Einträgen.',
  },
  ergebnis: {
    wann: '{satz} ({wann}).',
    zielgruppe:
      'Zielgruppe „{name}“ eingeordnet: {dabei} dabei, {pruefen} bitte prüfen, {nicht} nicht dabei',
    web: {
      done: 'Websuche fertig: {anzahl} Angaben mit Quelle gefunden',
      partial: 'Websuche teilweise gelungen: {anzahl} Angaben mit Quelle gefunden',
      failed:
        'Die Websuche hat nicht geklappt. Grund und nächsten Schritt liest du unter „Neue Zielpersonen finden“',
      cancelled: 'Die Websuche wurde beendet',
      refused: 'Die Websuche wurde abgelehnt. Ändere dein Suchprofil und versuche es erneut',
    },
    einfuegen: {
      done: 'Eingefügte Treffer bewertet: {anzahl} Treffer',
      partial: 'Eingefügte Treffer teilweise bewertet: {anzahl} Treffer',
      failed:
        'Die Bewertung der eingefügten Treffer hat nicht geklappt. Grund und nächsten Schritt liest du unter „Neue Zielpersonen finden“',
      cancelled: 'Die Bewertung der eingefügten Treffer wurde beendet',
      refused: 'Die Bewertung der eingefügten Treffer wurde abgelehnt',
    },
  },
  zusammenfassung: {
    neu: '{anzahl} neu dazu',
    weg: '{anzahl} nicht mehr dabei',
    nichtDabei: '{anzahl} nicht dabei',
    pruefen: '{anzahl} bitte prüfen',
    keineAenderung: 'Keine Änderung bei den Mitgliedern',
    stand: '{dabei} dabei, {pruefen} bitte prüfen, {nicht} nicht dabei.',
  },
  zielgruppe: {
    fehler:
      'Die Einordnung ist bei einigen Kontakten mehrmals gescheitert. Starte „Neu bewerten“, um es noch einmal zu versuchen.',
  },
  status: {
    fehlerTitel: 'Das hat nicht geklappt',
    fertigTitel: 'Fertig',
    ausblenden: 'Ausblenden',
    fortschritt: 'Fortschritt',
    stand: '{fertig} von {alle} ({prozent})',
  },
} as const;
